var cibMicrosoft = ["32 32", "<path d='M15.198 32h-15.198v-15.198h15.198zM32 32h-15.198v-15.198h15.198zM15.198 15.198h-15.198v-15.198h15.198zM32 15.198h-15.198v-15.198h15.198z'/>"];

export { cibMicrosoft };
